export default __webpack_public_path__ + "static/media/logo2.f408d756.svg";